import {Button} from "react-bootstrap";
import styles from "./ButtonDownload.module.css";
import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMagnifyingGlassPlus} from "@fortawesome/free-solid-svg-icons";

export function ButtonMaximizar({onClick, fullWidth}) {
    return <Button className={`${styles.btnDownload} ${fullWidth?'w-100':''}`} onClick={onClick}>
        <span>Maximizar </span>
        <span className="material-symbols-outlined material-symbols-button">zoom_in</span>
    </Button>
}
